//reusable cookies functionality
(function () {
  RS.Utils.Cookies = {
    reflnkViewDesktop: null,

    // set cookie name value expiry days
    setCookie: function (name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    },

    // get cookie cookie name
    getCookie: function (cname) {
      var _name = cname + '=';
      var _ca = document.cookie.split(';');
      var _cookVal = null;
      for (var i = 0; i < _ca.length; i++) {
        var c = _ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(_name) === 0) {
          _cookVal = c.substring(_name.length, c.length);
        }
      }
      return _cookVal;
    },
  };
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/utils/cookies.js
// module id = 60
// module chunks = 5 8